function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import SpzaComponent from './spzaComponent';
import { getWindow, getDocument } from '@shared/services/window';
import { logTelemetry } from '../utils/telemetryUtils';
import { Constants } from '../utils/constants';
import { logger } from '@src/logger';
import { withHydration } from 'hooks/useHydration';
class ScrollToTopButton extends SpzaComponent {
    componentDidMount() {
        if (__CLIENT__ && this.childElement) {
            getDocument().body.appendChild(this.childElement);
            getWindow().addEventListener('scroll', this.handleScroll.bind(this));
        }
    }
    componentWillUnmount() {
        if (__CLIENT__ && this.childElement) {
            getWindow().removeEventListener('scroll', this.handleScroll.bind(this));
            getDocument().body.removeChild(this.childElement);
        }
    }
    get offsetY() {
        return this.props.offsetYToAppear ? this.props.offsetYToAppear : ScrollToTopButton.defaultOffsetY;
    }
    handleScroll() {
        const curWindow = getWindow();
        const yOffsetToAppear = this.offsetY;
        this.setState({
            isShowButton: curWindow && curWindow.pageYOffset > yOffsetToAppear
        });
    }
    goToThePageTop() {
        const curWindow = getWindow();
        if (curWindow) {
            curWindow.scrollTo(0, 0);
            logTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.ScrollToTopButton, 'Go back to the top of the page using the scroll to top button');
            logger.info('Go back to the top of the page using the scroll to top button', {
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.ScrollToTopButton
            });
        }
    }
    renderButton() {
        return this.state.isShowButton && /*#__PURE__*/ _jsx("button", {
            className: "appSourceScrollToTop",
            onClick: ()=>this.goToThePageTop(),
            "aria-label": "Scroll to top"
        });
    }
    renderImpl() {
        if (!this.props.isHydrated) {
            return null;
        }
        return /*#__PURE__*/ ReactDOM.createPortal(this.renderButton(), this.childElement);
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "childElement", void 0);
        this.state = {
            isShowButton: false
        };
        if (__CLIENT__) {
            var _getDocument;
            this.childElement = (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.createElement('div');
        }
    }
}
_define_property(ScrollToTopButton, "defaultOffsetY", 90);
export default withHydration(ScrollToTopButton);
